<template>




        <div class="container" :class="{ containerRJI: nomeEmpresa == 'RJI' || nomeEmpresa == 'ACTUAL' }">

        <div v-if="!requisicaoFinalizada" class="loading-overlay">
            <div class="spinner"></div>
        </div>

            <div class="left-side">
                <div v-if="openToken" class="form-container">
                    <p style="cursor: pointer; margin-top: 10px; align-self: flex-start; cursor: pointer; display: inline-flex;"
                        @click="voltar()"><img src="@/assets/arrow.svg" /> Voltar</p>
                    <div
                        style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                        <div>
                            <img src="@/assets/cadeado_com_fundo.svg" />
                        </div>
                        <h2 style="color: #00235C; font-size: 30px;">Chave de acesso</h2>
                        <div class="header" style="margin-top: 0; padding-top: 20px;">
                            <p v-if="openToken" style="margin-top: 0;">
                                Para continuar, digite o código que acabamos de enviar para o seu e-mail.
                            </p>
                        </div>
                    </div>
                    <form class="form" @submit.stop.prevent="sendRegisterWithToken">
                        <div class="input-field">
                            <label for="password">Chave de acesso</label>
                            <input type="password" v-model="token" class="field" autocomplete="off"
                                @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                            <p class="erro" style="max-width: 360px; display: flex;">{{ messageError }}</p>
                        </div>
                        <button type="button" @click="sendRegisterWithToken()" v-if="nomeEmpresa == 'GENIAL'"
                            :disabled="disableBtnConcluir" :class="{ disabledBtn: disableBtnConcluir }"
                            class="submit-button">
                            <span class="btnText" v-if="!disableBtnConcluir">Concluir</span>
                            <div class="loadingDots" v-if="disableBtnConcluir">
                                <span class="dot">.</span>
                                <span class="dot2">.</span>
                                <span class="dot3">.</span>
                            </div>
                        </button>
                    </form>
                </div>
                <div v-if="!openToken" class="form-container">
                    <h2>Cadastre-se</h2>
                    <img src="@/assets/progressoCadastro.png" alt="Logo" class="logoProgresso"
                        v-if="nomeEmpresa != 'RJI' && nomeEmpresa != 'ACTUAL'">
                    <img src="@/assets/progressoCadastro_rji.png" alt="Logo" class="logoProgresso"
                        v-if="nomeEmpresa == 'RJI' || nomeEmpresa == 'ACTUAL'">
                    <form>
                        <label for="tipoCadastro">Tipo de cadastro*</label>
                        <select id="tipoCadastro" v-model="cadastro.selectedTipoCliente" @change="limparCadastro">
                            <option value="selecione" disabled>Selecione um tipo</option>
                            <!--<option value="PJ">Pessoa Jurídica</option>
                            <option value="PF">Pessoa Física</option>
                            <option value="FU">Fundo de Investimento</option>
                            -->
                            <option v-for="tipo in tiposClientes" :key="tipo.value" :value="tipo.value">
                                {{ tipo.label }}
                            </option>
                        </select>
                        <div v-if="cadastro.selectedTipoCliente == '2' || cadastro.selectedTipoCliente == '3'">
                            <label for="cnpj">CNPJ*</label>
                            <input type="text" v-model="cadastro.cnpj" @blur="verifyCNPJ" id="cnpj"
                                v-mask="'##.###.###/####-##'" placeholder="00.000.000/0000-00">
                        </div>
                        <label for="nomeRazaoSocial"
                            v-if="cadastro.selectedTipoCliente == '2' || cadastro.selectedTipoCliente == '3'">Razão
                            Social*</label>
                        <label for="nomeRazaoSocial"
                            v-if="cadastro.selectedTipoCliente == '1' || cadastro.selectedTipoCliente == 'selecione'">Nome
                            completo*</label>
                        <input type="text" v-model="cadastro.nomeRazaoSocial" id="nomeRazaoSocial">
                        <div v-if="cadastro.selectedTipoCliente == '1' || cadastro.selectedTipoCliente == 'selecione'">
                            <label for="cnpj">CPF*</label>
                            <input type="text" v-model="cadastro.cpf" id="cnpj" v-mask="'###.###.###-##'"
                                placeholder="000.000.000-00">
                        </div>
                        <div v-if="cadastro.selectedTipoCliente == '2' && nomeEmpresa == 'GENIAL'">
                            <label for="cnpj">Data de Constituição*</label>
                            <input type="text" v-model="cadastro.dataConstituicao" id="dataConstituicao"
                                v-mask="'##/##/####'">
                        </div>
                        <label for="email">E-mail*</label>
                        <input type="email" v-model="cadastro.email" id="email" placeholder="Insira seu e-mail">
                        <div class="label__field"
                            v-if="configuracaoApelido == 'S' && cadastro.selectedTipoCliente !== '1' && cadastro.selectedTipoCliente !== 'selecione'">
                            <div style="display: flex;">
                                <label class="label" for="apelido">Apelido*</label>
                                <i class="fa fa-info-circle info-icon"
                                    title="O Apelido de Conta permite que você personalize a identificação das suas contas de forma única. Isso facilita o reconhecimento e o acesso rápido, especialmente para quem gerencia múltiplas contas ou perfis. Lembre-se: cada apelido deve ser exclusivo para uma conta específica, ajudando você a diferenciar suas contas com facilidade no dia a dia!"></i>
                            </div>
                            <input class="field" type="text" v-model="cadastro.apelido" id="apelido" @input="validarApelido"
                                @blur="checkApelidoLength" placeholder="Insira seu apelido" style="width: 108%">
                            <p v-if="apelidoError" class="erro">{{ apelidoError }}</p>
                            <p class="erro" style="font-size: 11px;">
                                O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou
                                minúsculas) e números. Não é permitido o uso de caracteres especiais.
                            </p>
                        </div>
                        <button v-if="nomeEmpresa != 'GENIAL'" type="button" class="submit-button"
                            :class="{ 'disabled': $v && $v.cadastro && $v.cadastro.$invalid }"
                            @click="avancar()">Avançar</button>
                        <button type="button" @click="receberToken()" v-if="nomeEmpresa == 'GENIAL'"
                            :disabled="disableBtnReceberToken" :class="{ disabledBtn: disableBtnReceberToken }"
                            class="submit-button">
                            <span class="btnText" v-if="!disableBtnReceberToken">Receber Código de acesso</span>
                            <div class="loadingDots" v-if="disableBtnReceberToken">
                                <span class="dot">.</span>
                                <span class="dot2">.</span>
                                <span class="dot3">.</span>
                            </div>
                        </button>
                    </form>
                    <div class="footer">
                        <!--<p>Já possui uma conta? <router-link :to="loginLink">Entrar</router-link></p>-->
                        <p>Já possui uma conta? <a :href="loginLink">Entrar</a></p>
                    </div>
                </div>
            </div>
            <div class="right-side"
                :class="{ rightSideGenial: nomeEmpresa == 'GENIAL', rightSideActual: nomeEmpresa == 'ACTUAL', rightSideRJI: nomeEmpresa == 'RJI' }">
                <!-- A imagem pode ser definida via CSS para responsividade -->
            </div>
        </div>

</template>

<script>
import { required, email, minLength } from '@vuelidate/validators';
import validateCpf from '@/utils/validateCpf';
import validateCnpj from '@/utils/validateCnpj';
import api from '@/api/axios';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
export default {
    name: 'CadastroInicio',
    data() {
        return {
            nomeEmpresa: '',
            hashToken: '',
            requisicaoFinalizada: true,
            openToken: false,
            messageError: '',
            token: '',
            erro: false,
            disableBtnReceberToken: false,
            disableBtnConcluir: false,
            cadastro: {
                selectedTipoCliente: 'selecione',
                cnpj: null,
                cpf: null,
                nomeRazaoSocial: null,
                email: null,
                apelido: null,
                dataConstituicao: null
            },
            permitirAvancar: false,
            apelidoError: '',
            tiposClientes: [],
            configuracaoTiposClientes: {},
            configuracaoURLEntrar: '',
            configuracaoApelido: '',
            loginLink: '/Login'
        };
    },
    computed: {
        ...mapGetters({
            account: 'GET_CREATE_ACCOUNT',
            getConfiguracoes: 'GET_CONFIGURACOES',
        })
    },
    validations() {
        const validations = {
            email: { required, email },
        };
        if (this.cadastro.selectedTipoCliente === '1') {
            validations.CPF = {
                required,
                validateCpf
            };
            validations.nomeCompleto = {
                required,
                minLength: minLength(5) // Supondo que o nome completo deve ter pelo menos 5 caracteres
            };
        } else if (this.cadastro.selectedTipoCliente === '2') {
            validations.CNPJ = {
                required,
                validateCnpj
            };
            validations.razaoSocial = {
                required,
                minLength: minLength(5) // Supondo que o nome completo deve ter pelo menos 5 caracteres
            };
        }
        return { cadastro: validations };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.resetCadastro();
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.resetCadastro();
        next();
    },
    async created() {
        await this.fetchConfiguracao(['Remover tipo de cadastro', 'Redirecionamento do botão entrar Onboarding externo', 'Exibir apelido']);
        this.configuracaoTiposClientes = this.getConfiguracoes('Remover tipo de cadastro');
        this.configuracaoURLEntrar = this.getConfiguracoes('Redirecionamento do botão entrar Onboarding externo');
        this.configuracaoApelido = this.getConfiguracoes('Exibir apelido').Valor;
        if (this.configuracaoURLEntrar) {
            this.loginLink = this.configuracaoURLEntrar.Valor;
        }
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        if (this.account != null) {
            this.cadastro = this.account;
        }
        if (this.nomeEmpresa == 'GENIAL') {
            this.cadastro.selectedTipoCliente = '2';
        }
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        voltar() {
            this.openToken = false;
        },
        verifyCNPJ() {
            this.requisicaoFinalizada = false;
            const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
            if (this.cadastro.cnpj == '' || this.cadastro.cnpj == null) {
                this.requisicaoFinalizada = true;
                return;
            }
            if (this.cadastro.cnpj.length > 0 && !cnpjRegex.test(this.cadastro.cnpj)) {
                this.requisicaoFinalizada = true;
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `O CNPJ informado é inválido! Verifique os dados e tente novamente.`,
                });
                return;
            }
            var encodedCredentials = btoa('sat@sat:sat23!');
            api.get(`/register/verifyCNPJ?cnpj=${this.cadastro.cnpj}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    this.requisicaoFinalizada = true;
                    if (retorno.status == 200) {
                        if (retorno.data.RazaoSocial == '' || retorno.data.RazaoSocial == null) {
                            this.$swal({
                                icon: 'error',
                                title: 'Oops...',
                                text: `O CNPJ informado não foi encontrado! Verifique os dados e tente novamente.`,
                            });
                            this.cadastro = {
                                selectedTipoCliente: '2',
                                cnpj: null,
                                cpf: null,
                                nomeRazaoSocial: null,
                                email: null,
                                apelido: null,
                                dataConstituicao: null
                            }
                        }
                        this.cadastro.nomeRazaoSocial = retorno?.data?.RazaoSocial;
                        this.cadastro.dataConstituicao = retorno?.data?.DataConstituicao;
                    }
                })
        },
        limparCadastro() {
            this.cadastro.razaoSocial = null;
            this.cadastro.cnpj = null;
            this.cadastro.cpf = null;
            this.cadastro.nomeRazaoSocial = null;
            this.cadastro.email = null;
            this.cadastro.apelido = null;
            this.cadastro.dataConstituicao = null;
            this.hashToken = '';
        },
        resetCadastro() {
            this.cadastro.selectedTipoCliente = 'selecione';
            this.cadastro.razaoSocial = null;
            this.cadastro.cnpj = null;
            this.cadastro.cpf = null;
            this.cadastro.nomeRazaoSocial = null;
            this.cadastro.email = null;
            this.cadastro.apelido = null;
            this.cadastro.dataConstituicao = null;
            this.hashToken = '';
        },
        validarApelido(event) {
            if (this.configuracaoApelido === 'S') {
                const value = event.target.value;
                const regex = /[^a-zA-Z0-9]/g;
                this.cadastro.apelido = value.replace(regex, '').slice(0, 20);
            }
        },
        checkApelidoLength(event) {
            if (!this.cadastro.apelido || this.cadastro.apelido.length < 3) {
                this.apelidoError = 'O campo apelido deve ter no mínimo três caracteres.';
                event.target.focus();
            } else {
                this.apelidoError = '';
            }
        },
        validarAvancar() {
            var nomeCampo = '';
            if (nomeCampo == '' && (this.cadastro.selectedTipoCliente == '' || this.cadastro.selectedTipoCliente == 'selecione')) {
                nomeCampo = 'Tipo de cadastro';
            }
            if (nomeCampo == '' && (this.cadastro.selectedTipoCliente == '1' && (this.cadastro.cpf == '' || this.cadastro.cpf == null))) {
                nomeCampo = 'CPF';
            }
            if (nomeCampo == '' && ((this.cadastro.selectedTipoCliente == '2' || this.cadastro.selectedTipoCliente == '3')
                && (this.cadastro.cnpj == '' || this.cadastro.cnpj == null))) {
                nomeCampo = 'CNPJ';
            }
            if (nomeCampo == '' && (this.cadastro.selectedTipoCliente == '1' && (this.cadastro.nomeRazaoSocial == '' || this.cadastro.nomeRazaoSocial == null))) {
                nomeCampo = 'Nome completo';
            }
            if (nomeCampo == '' && ((this.cadastro.selectedTipoCliente == '2' || this.cadastro.selectedTipoCliente == '3')
                && (this.cadastro.nomeRazaoSocial == '' || this.cadastro.nomeRazaoSocial == null))) {
                nomeCampo = 'Razão Social';
            }
            if (nomeCampo == '' && (this.cadastro.email == '' || this.cadastro.email == null)) {
                nomeCampo = 'E-mail';
            }
            if (nomeCampo == '' && this.configuracaoApelido === 'S' && ((this.cadastro.selectedTipoCliente == '2' || this.cadastro.selectedTipoCliente == '3')
                && (this.cadastro.apelido == '' || this.cadastro.apelido == null))) {
                nomeCampo = 'Apelido';
            }
            if (nomeCampo != '') {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `É necessário preencher o campo ` + nomeCampo + `.`,
                });
                return false;
            }
            if (this.configuracaoApelido === 'S' && this.cadastro.selectedTipoCliente != '1') {
                this.validarApelido({ target: { value: this.cadastro.apelido } });
                if (this.apelidoError) {
                    return false;
                }
            }
            return true;
        },
        avancar() {
            if (!this.validarAvancar()) {
                return;
            } else {
                this.$store.commit('SET_CREATE_ACCOUNT', this.cadastro);
                this.$router.push({ name: 'CadastroFinalizacao' });

            }
        },
        async sendRegisterWithToken() {
            this.disableBtnConcluir = true;
            if (this.token == '' || this.token == null) {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Token informado é inválido.`,
                });
                this.disableBtnConcluir = false;
                return;
            }
            if (this.validarAvancar()) {
                const encodedCredentials = btoa('sat@sat:sat23!');
                var registerObj = {
                    TipoCadastro: 'pessoa jurídica',
                    CpfCnpj: this.cadastro.cnpj,
                    NomeRazaoSocial: this.cadastro.nomeRazaoSocial,
                    Email: this.cadastro.email,
                    DataConstituicao: this.cadastro.dataConstituicao,
                    Password: this.token,
                    HashToken: this.hashToken
                };
                try {
                    const retorno = await api.post('/register/registerWithToken', registerObj, {
                        headers: { 'Authorization': `Basic ${encodedCredentials}` }
                    });
                    this.disableBtnConcluir = false;
                    if (!typeof retorno.data[0] === 'string' && retorno.data[0].includes('Token')) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Senha informada não atende aos critérios. É necessário possuir o mínimo de 8 caracteres, sendo ao menos 1 letra maiúscula, 1 minúscula e 1 caractere especial.`,
                        });
                    } else {
                        this.hashToken = '';
                        this.openToken = false;
                        this.disableBtnConcluir = false;
                        this.$store.commit('SET_CREATE_ACCOUNT', []);
                        // this.$swal({
                        //     icon: 'success',
                        //     title: 'Cadastro realizado!',
                        //     text: `O cadastro foi efetuado com sucesso`,
                        // });
                        const model = { Usuario: this.cadastro.email, Senha: this.token, Apelido: '' };
                        await this.signIn(model)
                            .then(response => {
                                this.limparCadastro();
                                this.disableBtnLogin = false;
                                if (response.status == 200) {
                                    this.messageError = '';
                                    this.erro = false;
                                    this.$router.replace({
                                        path: '/',
                                    });
                                }
                            })
                            .catch((error) => {
                                this.limparCadastro();
                                this.disableBtnLogin = false;
                                if (error.response.data == '') {
                                    this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                                    this.erro = true;
                                } else if (error.response.data?.data[0] == 'Cliente não validado o e-mail!') {
                                    this.messageError = 'Falha na autenticação. Confirme seu endereço de e-mail.';
                                    this.erro = true;
                                    this.habilitarReenviarEmail = true;
                                } else {
                                    this.messageError = error.response.data?.data[0];
                                    this.erro = true;
                                }
                            });
                    }
                } catch (error) {
                    console.error('Erro ao criar a conta:', error);
                    this.$swal({
                        icon: 'error',
                        title: 'Erro',
                        text: error?.response?.data?.descricao != '' ? error?.response?.data?.descricao : 'Dados inválidos',
                    });
                } finally {
                    this.disableBtnConcluir = false; // Reativa o botão, independentemente do sucesso ou erro
                }
            } else {
                this.disableBtnReceberToken = false;
            }
        },
        async receberToken() {
            this.disableBtnReceberToken = true;
            if (this.validarAvancar()) {
                const encodedCredentials = btoa('sat@sat:sat23!');
                await api
                    .post('/register/sendEmailPreRegister', this.cadastro, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                    .then((retorno) => {

                        this.hashToken = retorno.data;
                        this.openToken = true;
                        this.disableBtnReceberToken = false;
                    })
                    .catch((error) => {

                    this.$swal({
                        icon: 'error',
                        title: 'Erro',
                        text: error?.response?.data?.data != '' ? error?.response?.data?.data : 'Dados inválidos',
                    });

                        this.disableBtnReceberToken = false;
                    });
                return;
            } else {
                this.disableBtnReceberToken = false;
            }
        },
    },
    watch: {
        consultarPermissaoAvancar() {
            this.permitirAvancar = false;
            if (this.cadastro.selectedTipoCliente == '1') {
                // Para Pessoa Física, nome completo e CPF são obrigatórios
                if (this.cadastro.nomeCompleto && this.cadastro.nomeCompleto.length > 5 && this.validarCPF(this.cadastro.CPF)) {
                    this.permitirAvancar = true;
                }
            } else if (this.cadastro.selectedTipoCliente == '2' || this.cadastro.selectedTipoCliente == '3') {
                // Para Pessoa Jurídica ou Funcionário, razão social e CNPJ são obrigatórios
                if (this.cadastro.razaoSocial && this.cadastro.CNPJ && this.validarCNPJ(this.cadastro.CNPJ)) {
                    this.permitirAvancar = true;
                }
            }
        },
        configuracaoTiposClientes(newVal) {
            if (newVal && newVal.Valor) {
                const valores = newVal.Valor.replace('\r\n', ';').replace(',', ';').split(';').map(item => item.trim()).filter(item => item);
                const todasOpcoes = [
                    { value: '1', label: 'Pessoa Física' },
                    { value: '2', label: 'Pessoa Jurídica' },
                    { value: '3', label: 'Fundo de Investimento' }
                ];
                const tiposFiltrados = todasOpcoes.filter(opcao => !valores.includes(opcao.value));
                if (JSON.stringify(tiposFiltrados) !== JSON.stringify(this.tiposClientes)) {
                    this.tiposClientes = tiposFiltrados;
                }
            } else {
                if (this.tiposClientes.length > 0) {
                    this.tiposClientes = [];
                }
            }
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    min-height: 100vh;
    /* Viewport height */
    overflow: hidden;
    /* Isso pode ajudar a impedir o scroll indesejado */
}

.logoProgresso {
    width: 380px;
    height: 10px;
}

h2 {
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    /* Semibold */
    font-size: 30px;
    line-height: 38px;
    color: #101828;
    /* Gray/900 */
}

.right-side {
    width: 50%;
    background: url('@/assets/fundoCadastro.png') no-repeat center center;
    background-size: cover;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideGenial {
    width: 50%;
    background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('@/assets/fundoGenialCadastro.png') !important;
    background-size: cover;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

/* Aplicando estilos de fonte */
button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

input,
select {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    /* Ajuste para a linha de altura */
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Arredondamento dos inputs */
    box-sizing: border-box;
    /* Garante que o padding não adicione largura extra */
    width: 100%;
    /* Para garantir que os inputs ocupem toda a largura do container */
}

/* Estilos para os rótulos (labels) do formulário */
form label {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 500;
    /* Peso médio da fonte */
    font-size: 14px;
    /* Tamanho da fonte */
    line-height: 20px;
    /* Altura da linha */
    color: #344054;
    /* Cor do texto em cinza escuro */
}

.rightSideRJI {
    width: 50%;
    background: linear-gradient(rgba(15, 37, 71, 0.5), rgba(15, 37, 71, 0.5)), url('@/assets/fundoRJI.png') !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideActual {
    width: 50%;
    background: url('@/assets/fundo_actual_secundario.png') !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    overflow: hidden;
    /* Isso impedirá que o conteúdo excedente cause scroll */
}

.containerRJI {
    background-color: rgba(15, 37, 71, 1) !important;
    color: #FFF;
}

.containerRJI h2 {
    color: #FFF !important;
}

.containerRJI p {
    color: #FFF !important;
}

.containerRJI label {
    color: #FFF !important;
}

.containerRJI a {
    color: #FFF !important;
    font-weight: 800;
}

.footer {
    text-align: center;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    /* Este é um cinza genérico, ajuste conforme necessário */
    font-size: 16px;
    /* Exemplo de tamanho de fonte, ajuste conforme necessário */
    line-height: 24px;
    /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
    font-weight: 600;
    /* Para 'Cadastre-se', que parece ser mais destacado */
    color: #101828;
    /* Este é o azul padrão de links, ajuste conforme necessário */
    text-decoration: none;
    /* Para sublinhar o link */
}

/* Estilos para o formulário */
form {
    display: flex;
    flex-direction: column;
}

/* Estilos para os inputs */
input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.left-side {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
}

.header p {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 400;
    /* Peso normal da fonte */
    font-size: 16px;
    /* Tamanho da fonte */
    line-height: 24px;
    /* Altura da linha */
    text-align: center;
    /* Alinhamento do texto ao centro */
    color: #6E6E6E;
    /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.form-container {
    max-width: 400px;
    margin: 0 auto;
}

input,
select {
    width: 100%;
    padding: 0.5rem;
    margin: 0.5rem 0;
    border: 1px solid #ccc;
}

.submit-button {
    width: 100%;
    padding: 0.5rem;
    margin-top: 1rem;
    color: white;
    border: none;
    cursor: pointer;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
}

/* Responsividade */
@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }

    .left-side,
    .right-side {
        width: 100%;
    }

    .right-side {
        background-size: contain;
        /* ou você pode tentar 100% 100% para forçar a cobertura completa */
        height: auto;
        /* ajuste a altura para manter a proporção da imagem */
    }
}
</style>
